// @ts-ignore
import {createI18n} from 'vue-i18n'//引入vue-i18n组件
import store from "../store/index";


import en from './en'
import zh from './zh'

const messages = {
    'zh_CN': zh,
    'en_US': en
}


const localeData = {
    legacy: false, // composition API
    globalInjection: true, //全局生效$t
    locale: store.state.language || 'zh_CN', // 默认cn翻译
    messages
}

const i18n = createI18n(localeData)
export default i18n
